module.exports = __webpack_public_path__ + "static/black-future-88-rgba-5a75c05ae9a95ca315fdda08fa19706a.png";